import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import { ThemeProvider, alpha, createTheme } from '@mui/material/styles';

// Builds on the ERP's theme (App.jsx: Inter, table styles) with the module's "Logo Blue" palette:
// blue for the brand and positive states, slate greys for text and neutral states, amber/red only
// for problems. Status chips are soft tints rather than solid fills. Chat bubbles and the
// template preview keep WhatsApp's look on purpose.
const withModuleTweaks = (outer) => createTheme(outer, {
  palette: {
    primary: { main: '#1565C0', dark: '#0D47A1', light: '#64B5F6', contrastText: '#FFFFFF' },
    secondary: { main: '#4A5668', dark: '#2E3A4B', light: '#9AA8BA', contrastText: '#FFFFFF' },
    info: { main: '#1E88E5', dark: '#0D47A1', light: '#90CAF9', contrastText: '#FFFFFF' },
    warning: { main: '#B45309', dark: '#8A3F07', light: '#F5C27A', contrastText: '#FFFFFF' },
    error: { main: '#B42318', dark: '#8C1B12', light: '#F3A59F', contrastText: '#FFFFFF' },
    text: { primary: '#0F2440', secondary: '#5B6B80' },
    divider: '#E1E7EF',
    background: { default: '#F4F6FA', paper: '#FFFFFF' }
  },
  components: {
    MuiButton: { styleOverrides: { root: { textTransform: 'none', fontWeight: 600, borderRadius: 8 } } },
    MuiTab: { styleOverrides: { root: { textTransform: 'none', fontWeight: 600 } } },
    // Table headers match the Email Marketing tables: the ERP's blue bar with white labels.
    MuiTableCell: {
      styleOverrides: {
        head: {
          color: '#FFFFFF',
          background: 'linear-gradient(135deg, #1976D2, #125A9C)',
          whiteSpace: 'nowrap',
          '& .MuiIconButton-root': { color: 'rgba(255,255,255,0.75)' },
          '& .MuiIconButton-root:hover': { color: '#FFFFFF', backgroundColor: 'rgba(255,255,255,0.15)' }
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: ({ ownerState, theme }) => {
          const tone = ownerState.color && ownerState.color !== 'default' && theme.palette[ownerState.color];
          if (ownerState.variant === 'outlined') return { fontWeight: 600 };
          return tone
            ? { fontWeight: 600, backgroundColor: alpha(tone.main, 0.12), color: tone.dark }
            : { fontWeight: 600, backgroundColor: '#EEF1F5', color: '#4A5668' };
        }
      }
    }
  }
});

export default function WhatsAppLayout() {
  return (
    <ThemeProvider theme={withModuleTweaks}>
      <Box sx={{ width: '100%', minHeight: '100%', bgcolor: 'background.default' }}>
        <Container maxWidth="xl" sx={{ py: 2 }}>
          <Outlet />
        </Container>
      </Box>
    </ThemeProvider>
  );
}
